import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline'
import {
  OptionsPopoverItems,
  type OptionItem,
} from '@/core/popover/options/OptionsPopoverItems.tsx'

export type NodeOptionPopoverItem = 'Rename' | 'Delete'

export interface HierarchyNodeOptionsPopoverItemsProps {
  onItemSelected: (item: NodeOptionPopoverItem) => void
}

const options: OptionItem<NodeOptionPopoverItem>[] = [
  { value: 'Rename', label: 'Rename', icon: <DriveFileRenameOutlineIcon fontSize="small" /> },
  {
    value: 'Delete',
    label: 'Delete',
    icon: <DeleteOutlineIcon fontSize="small" />,
    isDelete: true,
  },
]

export function HierarchyNodeOptionsPopoverItems({
  onItemSelected,
}: HierarchyNodeOptionsPopoverItemsProps) {
  return <OptionsPopoverItems options={options} onItemSelected={onItemSelected} />
}
